import { url as locationsURL } from '../index';
import ApiService from '@api/api-service';

export const url = `${locationsURL}`;
export default new ApiService(url);
